import React from "react";
import styled, { css } from "styled-components";
import { SvgCheck } from "../Svgs/Check";

const CheckIcon = styled(SvgCheck)`
  height: 12px;
  width: 12px;
`;

export const CheckIconContainer = styled.div`
  height: 14px;
  width: 14px;
  border: 1px solid #cccccc;
  border-radius: 2px;
  background: transparent;
  margin: 3px;
  ${(props: any) =>
    props.isSelected &&
    css`
      background: #1b0076;
      border: 1px solid white;
      cursor: default;
    `};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-shrink: 0;
  flex-grow: 0;
  color: #fff;
  svg {
    fill: #fff;
  }
`;

type Props = {
  isSelected: boolean;
  icon?: any;
  disabled?: boolean;
  style?: any;
};
export const CheckboxInput = ({
  isSelected,
  icon = null,
  disabled,
  ...props
}: Props) => {
  return (
    <CheckIconContainer {...{ isSelected, disabled, ...props }} tabIndex={0}>
      {isSelected && !disabled && (icon || <CheckIcon />)}
    </CheckIconContainer>
  );
};
